package linkerpangoquipdb

import app.cash.sqldelight.ColumnAdapter
import kotlin.Double
import kotlin.Int
import kotlin.Long
import kotlin.String

public data class Vehicle(
  public val vin: String,
  public val plate: String,
  public val brand: String,
  public val model: String,
  public val vehicle_type: String,
  public val year: Long,
  public val color: String,
  public val owner: String,
  public val engine_oil: String,
  public val front_tire_size: String,
  public val rear_tire_size: String,
  public val front_tire_pressure_below_160: Double,
  public val rear_tire_pressure_below_160: Double,
  public val front_tire_pressure_above_160: Double,
  public val rear_tire_pressure_above_160: Double,
  public val recommended_fuel: String,
  public val engine_details: String,
  public val cylinder_count: Int,
  public val front_bulb_type: String,
  public val rear_bulb_type: String,
  public val battery_specs: String,
  public val coolant_type: String,
  public val signature: String?,
  public val next_revision_date: Long?,
  public val next_itv_date: Long?,
  public val first_registration_date: Long?,
) {
  public class Adapter(
    public val cylinder_countAdapter: ColumnAdapter<Int, Long>,
  )
}
